var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box"},[_c('div',{ref:"student",staticClass:"chart"}),_vm._v(" "),_c('div',{staticClass:"table"},[_c('div',{staticStyle:{"border-bottom":"1px solid #fff"}},[_vm._v("安全预警处理情况")]),_vm._v(" "),_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"240px"},attrs:{"config":_vm.config}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747d35a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataBoard/lineChart.vue
// module id = null
// module chunks = 